import frenchPlacePhraseFormatter from './french/frenchPlacePhraseFormatter'
import type { FormatPlaceInput, PlacePhraseFormatter, PlacePhraseIntent } from './types'

export type { FormatPlaceInput, PlacePhraseIntent }

const defaultPlacePhraseFormatter: PlacePhraseFormatter = {
  format: (place) => place.name,
}

// TODO: Extract to own lib and add more languages
const placePhraseFormatters: Partial<Record<string, PlacePhraseFormatter>> = {
  fr: frenchPlacePhraseFormatter,
}

export function formatPlacePhrase(
  place: FormatPlaceInput,
  locale: string,
  intent: PlacePhraseIntent,
): string {
  const normalisedLocale = locale.replace(/_/g, '-')
  const language = normalisedLocale.split('-')[0].toLowerCase()
  const formatter = placePhraseFormatters[language] ?? defaultPlacePhraseFormatter

  return formatter.format(place, normalisedLocale, intent)
}
